export default __webpack_public_path__ + "static/media/flex.ff900d5d.svg";